import React from 'react';
import { useTranslation } from 'react-i18next';
import { Theme, createStyles, makeStyles } from '@material-ui/core';
import { LOCALE_LABEL } from '@marketiq/marketiq-core-data';
import { LOCALE_TO_I18N } from '../../utilities';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      '@media (max-width: 767px)': {
        display: 'none',
      },
    },
    button: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      font: 'Calibre-R',
      fontSize: 14,
      color: theme.palette.primary.contrastText,
      padding: '0 4px',
      '&:hover': {
        color: theme.palette.primary.light,
      },
    },
    active: {
      color: theme.palette.primary.light,
      textDecoration: 'underline',
      textUnderlinePosition: 'under',
    },
    divider: {
      color: theme.palette.primary.contrastText,
      fontSize: 14,
      userSelect: 'none',
    },
  }),
);

type Props = {
  supportedLanguages?: string[];
};

const LanguageSwitcher: React.FC<Props> = ({ supportedLanguages }) => {
  const { i18n } = useTranslation();
  const classes = useStyles();

  const langs = supportedLanguages?.length ? supportedLanguages : [];

  // Nothing to switch between — hide the component
  if (langs.length <= 1) return null;

  const currentI18n = i18n.language?.split('-')[0];

  return (
    <div className={classes.container}>
      {langs.map((localeCode, index) => (
        <React.Fragment key={localeCode}>
          {index > 0 && <span className={classes.divider}>|</span>}
          <button
            className={`${classes.button} ${currentI18n === (LOCALE_TO_I18N[localeCode] ?? localeCode) ? classes.active : ''}`}
            onClick={() => i18n.changeLanguage(LOCALE_TO_I18N[localeCode] ?? 'en')}
            type="button"
          >
            {LOCALE_LABEL[localeCode] ?? localeCode.toUpperCase()}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

LanguageSwitcher.displayName = 'LanguageSwitcher';
export default LanguageSwitcher;
